// CarouselIndicator.tsx

import { useEffect, useRef, useState } from "react";
import {
  IndicatorContainer,
  StyledDiv,
  SvgWrapper,
} from "./CarouselIndicator.styles";
import { CarouselIndicatorProps } from "./CarouselIndicator.types";
import { StartSVG } from "./StartSVG";

export function CarouselIndicator({
  currentItem = 0,
  maxItems,
  height,
  width,
  color = "#EE4D37",
}: CarouselIndicatorProps) {
  const parentRef = useRef<HTMLDivElement>(null);
  const [parentWidth, setParentWidth] = useState(0);
  const percent = (currentItem / maxItems) * 100;

  useEffect(() => {
    const updateWidth = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const calculateMaxTranslation = (widthPercentage: number) => {
    return ((((100 - widthPercentage) / 100) * percent) / 100) * parentWidth;
  };

  return (
    <IndicatorContainer
      ref={parentRef}
      height={height}
      width={width}
      color={color}
    >
      <StyledDiv
        width="64%"
        transform={`translateX(${calculateMaxTranslation(64)}px)`}
      />
      <StyledDiv
        width="45%"
        transform={`translateX(${calculateMaxTranslation(45)}px)`}
      />
      <StyledDiv
        width="27%"
        transform={`translateX(${calculateMaxTranslation(27)}px)`}
      >
        <SvgWrapper percent={percent}>
          <StartSVG pathProps={{ fill: color }} />
        </SvgWrapper>
      </StyledDiv>
    </IndicatorContainer>
  );
}
